module.exports = __webpack_public_path__ + "frontend/images/white/carousel/account.png?afddb66e6ccf70539555875ef2e8d71b";